import type { IconProps } from 'iconsax-react';
import type { FC, FunctionComponent } from 'react';
import React from 'react';

type TProps = {
  title: string;
  subTitle: string;
  icon: FunctionComponent<IconProps>;
  className?: string;
};

const AddonHeader: FC<TProps> = ({ subTitle, icon, title, className }) => {
  return (
    <div
      className={`px-4 py-3 border-b border-r border-primary-200 flex gap-3 flex-1 ${className}`}
    >
      <div className='w-12 h-12 bg-primary-50 rounded-2xl p-3'>
        {icon &&
          React.createElement(icon, {
            size: 24,
            color: 'var(--color-gray-800)',
          })}
      </div>
      <div className='flex-col gap-0'>
        <p className='font-normal text-sm text-gray-600'>{subTitle}</p>
        <p className='font-medium text-gray-800 text-lg'>{title}</p>
      </div>
    </div>
  );
};

export default AddonHeader;
